var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScroll1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 6,
    fill: "#FD9849",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5798 29.5H53.8125C54.5815 29.4998 55.3246 29.7742 55.905 30.2729C56.4853 30.7715 56.8636 31.4606 56.9702 32.2132L56.9929 32.4344L57 32.65V50.85C57.0001 51.6482 56.6936 52.4166 56.1424 53.0001C55.5912 53.5835 54.8365 53.9384 54.0307 53.993L53.8125 54H26.1875C25.3798 54.0001 24.6022 53.6972 24.0118 53.1525C23.4215 52.6078 23.0624 51.8619 23.0071 51.0656L23 50.85V35.0986L34.6266 35.1L34.9042 35.0874C35.4578 35.0399 35.9891 34.8502 36.4456 34.5372L36.6666 34.3692L42.5798 29.5ZM34.6266 26C35.2782 26 35.9129 26.1974 36.4456 26.5628L36.6666 26.7308L39.6458 29.1822L35.3066 32.7564L35.1862 32.8418C35.0611 32.9189 34.9212 32.9694 34.7753 32.9902L34.6252 33L23 32.9986V29.15C22.9999 28.3518 23.3064 27.5834 23.8576 26.9999C24.4088 26.4165 25.1635 26.0616 25.9693 26.007L26.1875 26H34.6266Z",
    fill: "#FD9849"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll1);
export default __webpack_public_path__ + "static/media/scroll1.d5587b23.svg";
export { ForwardRef as ReactComponent };